<app-grid-container class="review-cover">
  <app-grid-row class="white-container">
    <app-grid-column>
      <app-grid-row>
        <app-grid-column>
          <app-progression-steps />

          <h1 class="review-cover__title">
            {{ "REVIEW_COVER_PAGE_TITLE" | translate }}
          </h1>

          <app-selected-appliances
            class="review-cover__selected-appliances-mobile-only"
          />
        </app-grid-column>
      </app-grid-row>

      <app-grid-row>
        <app-grid-column [md]="6">
          <app-benefits-list-covered-items
            [benefitsListCoveredItems]="coveredItems()"
          />

          <app-benefits-list-not-covered-items
            [benefitsListNotCoveredItems]="notCoveredItems()"
            class="review-cover__not-covered-items"
          />

          <app-benefits-list-additional-items
            [benefitsListAdditionalItems]="additionalItems()"
          />

          <app-legal-info-panel class="review-cover__legal-info-panel" />

          @if (localeIdIsGB()) {
            <app-trustbox class="review-cover__trustpilot" />
          }

          <app-link
            (click)="onChangeAppliancesClick()"
            [navigationLink]="{
              label: 'REVIEW_COVER_PAGE_CTA_CHANGE_APPLIANCES' | translate,
              routerPath: '/multi-plan/protection-details',
            }"
            class="review-cover__link"
          />
          @if (selectedAppliances().length > 0) {
            <app-link
              (click)="onChangeApplianceDetailsClick()"
              [navigationLink]="{
                label:
                  'REVIEW_COVER_PAGE_CTA_CHANGE_APPLIANCE_DETAILS' | translate,
                routerPath: '/multi-plan/appliance-details',
              }"
              class="review-cover__link"
            />
          }

          <div class="review-cover__button">
            <app-button
              (click)="continueClicked()"
              [disabled]="formSubmitted"
              [fill]="true"
              [loading]="formSubmitted"
            >
              <p class="review-cover__button-text">
                {{ "REVIEW_COVER_PAGE_CTA_CONTINUE" | translate }}
              </p>
            </app-button>
          </div>
        </app-grid-column>

        <app-grid-column
          [block]="'md'"
          [hidden]="'xs'"
          [md]="6"
          class="review-cover-column--right"
        >
          <app-selected-appliances
            [startCollapsed]="false"
            appSticky
            class="review-cover__selected-appliances"
          />
        </app-grid-column>
      </app-grid-row>
    </app-grid-column>
  </app-grid-row>
</app-grid-container>
